var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page-title-header"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "CustomerList",
      "extra-items": [{
        text: _vm.customer.name,
        to: 'CustomerDetailView',
        params: {
          customerID: this.customer.id
        }
      }, '代客註冊']
    }
  })], 1), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("代客註冊 - " + _vm._s(_vm.customer.name))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_vm._v(" 來源通路: " + _vm._s(_vm.customer.merchant.type_name) + "(" + _vm._s(_vm.customer.merchant.name) + ") ")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label": "Line 使用者名稱"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: _vm.customer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "name", $$v);
      },
      expression: "customer.name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label": "識別編號"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: _vm.customer.outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.customer, "outer_code", $$v);
      },
      expression: "customer.outer_code"
    }
  })], 1), _c('DynamicFormDashboard', {
    ref: "dynamicForm",
    attrs: {
      "input-subjects": _vm.inputSubjects
    },
    model: {
      value: _vm.dynamicFormData,
      callback: function callback($$v) {
        _vm.dynamicFormData = $$v;
      },
      expression: "dynamicFormData"
    }
  })], 1)]), _vm.hasSubmittedRegistration ? _c('div', {
    staticClass: "mt-4"
  }, [_c('h5', {
    staticClass: "font-weight-bold text-left"
  }, [_vm._v("註冊結果")]), _c('code', {
    staticClass: "d-block",
    domProps: {
      "innerHTML": _vm._s(_vm.registrationResult)
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-center mt-5"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [[_vm._v("返回")]], 2), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [[_vm._v("送出")]], 2)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }